module.exports = __webpack_public_path__ + "img/20210128_151341.9035ae84.jpg";